import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchLegalPageContent } from "../api/aboutusApi";
import ContentSkeleton from "./ContentSkeleton";
import Footer from "./Footer";
import Header from "./header";
import Subbanner from "./Subbanner";
import { useTranslation } from "react-i18next";

const slugMap: Record<string, string> = {
  about: "about-us",
  tndc: "terms",
  pp: "privacy-policy",
};

const AboutUs: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const [title, setTitle] = useState<string>("");
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const slug = slugMap[type || ""] || "about-us";

    if (type === "tndc") {
      setTitle(t("termsConditions"));
    } else if (type === "pp") {
      setTitle(t("privacyPolicy"));
    } else {
      setTitle(t("aboutUs"));
    }

    setLoading(true);
    fetchLegalPageContent(slug).then((html: string | undefined) => {
      if (html) {
        setHtmlContent(html);
      }
      setLoading(false);
    });
  }, [type, t]);

  return (
    <div className="w-full h-full">
      <Header />
      <Subbanner />
      <div className="bg-white px-4 py-10 max-w-5xl mb-10 mx-auto text-[#070B28] font-proxima">
        {loading ? (
          <ContentSkeleton />
        ) : (
          <>
            <h1 className="text-3xl font-bold mb-6">{title}</h1>
            <div
              className="text-base leading-relaxed"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
